import React, {useState} from 'react';
import { useDispatch} from 'react-redux'
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import { push } from 'redux-first-history'
import {
	AUTH_URLS
} from '../../utils/AppConfig'
import {
	intern_set_is_authenticated
} from '../../actions'
import {ReactComponent as XClose} from '../../assets/svg/x_close.svg'


const InternLoginOverlay = () => {
    const { t, i18n } = useTranslation();

	const dispatch = useDispatch()

	const [email, set_email] = useState('');
    const [password, set_password] = useState('');
    const [message, set_message] = useState(null);

    const close_clicked = (e) => {
        // redirect
        e.preventDefault()
        dispatch(push(`/${i18n.language}`))
    }
    
    const login_clicked = async (e) => {
        e.preventDefault();
        set_message(null); // Clear previous messages

		if(email === '' || password === '') {
			set_message(t('Bitte Benutzername und Passwort angeben'))
		} else {
	        try {
				/*  in firefox and chrome there is a problem with focus/focus ring on login with enter
					the focus stays on the field, but the dialog is closed. disabling the
					field does not work. CSS Problem? */
			    
	            const response_login = await axios.post(AUTH_URLS.LOGIN, {
	                email: email, 
	                password: password
	            });
				
	            const {
					is_authenticated,
					message,
				} = response_login.data;
	            
	            if(is_authenticated) {
                    // Ron's Dirty Harry Hack -> remove stupid nasty hanging flying focus on hit Enter
                    const page_container = document.getElementById('page-container');
                    page_container.click();

					dispatch(intern_set_is_authenticated(is_authenticated))
				} else {
					set_message(message);
				}
	            
	        } catch (error) {
	            const message = error.response?.data?.message || t('Login fehlgeschlagen');
	            set_message(message);
	        }
		}
    };

    return (
        <>
            <div className="modal-backdrop show"></div>
            <div className="modal show" tabIndex="-1" aria-modal="true" role="dialog" style={{display: 'block'}}>
                <div className="modal-dialog">
                    <div className="modal-content modal-bg-grey">
                        <div className="modal-header">
                            <div className="model-header-content">
                                <h5 className="modal-title">Login</h5>
                            </div>
                            <div className="close-handler-container">
                                <button className="close-handler" onClick={close_clicked}>
                                    <span className="visuallyhidden">{t("Login schliessen")}</span>
                                    <div className="close-icon">
                                        <div className="circle"></div>
                                        <XClose />
                                    </div>
                                </button>
                            </div>

                        </div>
                        <div className="modal-body floating-form">
                            <div className="form-field">
                                <label htmlFor="name">
                                    <input type="text" 
                                    	   id="username" 
                                    	   placeholder={t('Benutzername')}
                                    	   value={email}
                                    	   onChange={(e) => set_email(e.target.value)} />
                                        <span>{t('Benutzername')}</span>
                                </label>
                            </div>
                            <div className="form-field">
                                <label htmlFor="name">
                                    <input type="password" 
                                    	   id="password" 
                                    	   placeholder={t('Passwort')} 
                                    	   value={password} 
                                    	   onChange={(e) => set_password(e.target.value)}
                                    	   onKeyDown={(e) => e.key === 'Enter' && login_clicked(e)} />
                                    <span>{t('Passwort')}</span>
                                </label>
                            </div>
                            {message && (
                                <div className="error-message">
                                    {message}
                                </div>
                            )}
                        </div>

                        <div className="modal-footer">
                            <button type="button" className="button-intern" onClick={login_clicked}>
                                <div className={'button-bg'}></div>
                                <div className={'button-text'}>{t('Login')}</div>
                            </button>
                            <br/>
                            <br/>
                            <br/>
                            <a className={'textlink'} href={`/${i18n.language}/`}>{t('Zurück zum iLNP FV')}</a>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )

}

export default InternLoginOverlay